var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPasswordReset(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "48pt",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 48 48",
    width: "48pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.1 0 0 -.1 0 48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m60 400c-17-17-20-33-20-100 0-110 12-122 117-118 50 2 78 7 81 16s-16 12-70 12c-44 0-79 5-86 12-16 16-16 140 0 156 17 17 299 17 316 0 7-7 12-39 12-74 0-46 4-63 15-68 13-4 15 7 15 69 0 114-2 115-200 115-147 0-162-2-180-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134 309c-10-17 13-36 27-22 12 12 4 33-11 33-5 0-12-5-16-11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224 309c-10-17 13-36 27-22 12 12 4 33-11 33-5 0-12-5-16-11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314 309c-10-17 13-36 27-22 12 12 4 33-11 33-5 0-12-5-16-11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298 224c-30-16-58-61-58-94 0-53 57-110 110-110s110 57 110 110c0 34-28 78-60 95-36 19-67 19-102-1zm90-36c9-9 12-9 12 0 0 7 5 12 10 12 6 0 10-13 10-30 0-27-3-30-30-30-16 0-30 5-30 10 0 6 5 10 12 10 9 0 9 3 1 11-16 16-61 3-68-21-18-56 38-90 81-49 28 26 34 7 7-23-35-39-113-4-113 51 0 52 74 93 108 59z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordReset);
export default __webpack_public_path__ + "static/media/password-reset.961a21453878f76fbc67904cf39b6a9e.svg";
export { ForwardRef as ReactComponent };